// extracted by mini-css-extract-plugin
export default {"ImageContainer":"CardSquareItem_ImageContainer__SKL5N","TextContainer":"CardSquareItem_TextContainer__JuI7L","InfoTextContainer":"CardSquareItem_InfoTextContainer__YjFbn"};